import {BASE_PATH_PORTAL, TIMEOUT_TIME} from '../constants/general'
import axios from 'axios'


//- Post Boletin Emarsys
export async function postBoletin (raw) {
    const apiURL = `https://www.claroshop.com/suscribirseBoletin/`
    const newRaw = `correo=${encodeURIComponent(raw.raw.correo)}&genero=${encodeURIComponent(raw.raw.genero)}`

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        mode: 'no-cors',
		crossdomain: true,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        },
        data: newRaw
    }

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': 'Por favor intenta mas tarde.'
        }
    })
}